import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { PostTypeCards, PostTypeCardsSkeleton, usePostTypes } from "@/entities/taxonomy"
import { TaxonomyPostsPage } from "@/widgets/taxonomy-posts"

export function PostTypePage() {
	const { id } = useParams<{ id: string }>()
	const { data: postTypes = [], isLoading: typesLoading } = usePostTypes()

	const postType = useMemo(() => {
		if (!id || !postTypes.length) return null
		return postTypes.find((type) => type.id === id)
	}, [id, postTypes])

	return (
		<TaxonomyPostsPage
			entityId={id}
			entity={postType}
			taxonomyLoading={typesLoading}
			filterKey="formatId"
			notFoundMessage="Тип поста не найден"
			kindLabel="Формат"
			railTitle="Форматы"
			emptyMessage="Нет постов в этой категории"
			rail={
				typesLoading ? (
					<PostTypeCardsSkeleton />
				) : (
					<PostTypeCards postTypes={postTypes} selectedTypeId={postType?.id} />
				)
			}
		/>
	)
}
